import React from 'react';

export default function Logo({ width = "80", className = "" }) {
    return (
        <svg 
            viewBox="0 0 100 50" 
            width={width} 
            className={className} 
            xmlns="http://www.w3.org/2000/svg"
            dir="ltr" 
            style={{ direction: "ltr" }} 
        >
            {/* خلفية زرقاء لحرف W */}
            <rect x="5" y="5" width="40" height="40" rx="10" fill="#0d6efd" />
            
            {/* حرف W */}
            <text 
                x="25" 
                y="34" 
                fontFamily="system-ui, -apple-system, sans-serif" 
                fontSize="26" 
                fontWeight="900" 
                fill="#ffffff" 
                textAnchor="middle"
            >
                W
            </text>
            
            {/* حرف S */}
            <text 
                x="55" 
                y="35" 
                fontFamily="system-ui, -apple-system, sans-serif" 
                fontSize="30" 
                fontWeight="900" 
                fill="#212529"
            >
                S
            </text>

            {/* نقطة زرقاء (ديكور) */}
            <circle cx="78" cy="33" r="5" fill="#0d6efd" />
        </svg>
    );
}